import UpsellKanbanImage from 'assets/images/project_management/modals/upsell_kanban_tasks_modal/kanban_hint_modal.svg'
import UpsellSchedule from 'assets/images/project_management/modals/upsell_schedule_modal/upsell_schedule.png'
import { LOCAL_STORAGE_KEYS_FACTORIAL_TIPS } from 'config/Vars'
import { AvailableModules, Features } from 'generated/featureDefinitions'
import { compact } from 'lodash'

import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import UpsellModal from 'modules/upsell/components/UpsellModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

import { TProjectsUpsellRequestSources } from '..'
import { ProjectsUpsellRequestSources } from '../constants'

interface IUpsellRequestProps {
  requestSource: TProjectsUpsellRequestSources
  requestEvents: Features
}

const UpsellProjectsModal = ({
  showUpsellModal,
  scheduleUpsell,
  kanbanTasksUpsell,
}: {
  showUpsellModal: boolean
  scheduleUpsell: boolean
  kanbanTasksUpsell: boolean
}) => {
  const [upsellModalIsHidden, setUpsellModalIsHidden] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS_FACTORIAL_TIPS.hideProjectsUpsellModal
  )

  if (upsellModalIsHidden || !showUpsellModal) {
    return null
  }

  const handleModalClose = () => {
    setUpsellModalIsHidden(true)
  }

  const getRequestSource = (): IUpsellRequestProps => {
    if (kanbanTasksUpsell && scheduleUpsell) {
      return {
        requestSource: ProjectsUpsellRequestSources.kanbanAndSchedule,
        requestEvents: Features.projects_tasks,
      }
    }
    if (scheduleUpsell) {
      return {
        requestSource: ProjectsUpsellRequestSources.schedule,
        requestEvents: Features.projects_clients, // we don't have a schedule feature to request here, using the source instead
      }
    }

    return {
      requestSource: ProjectsUpsellRequestSources.kanbanTasks,
      requestEvents: Features.projects_tasks,
    }
  }

  const steps = compact([
    scheduleUpsell
      ? {
          src: UpsellSchedule,
          title: i18n.t('project_management.modals.upsell_projects_modal.step_schedule.title'),
          description: i18n.t(
            'project_management.modals.upsell_projects_modal.step_schedule.description'
          ),
        }
      : null,

    kanbanTasksUpsell
      ? {
          src: UpsellKanbanImage,
          title: i18n.t('project_management.modals.upsell_projects_modal.step_kanban.title'),
          description: i18n.t(
            'project_management.modals.upsell_projects_modal.step_kanban.description'
          ),
        }
      : null,
  ])

  const requestSource = getRequestSource()

  return (
    <UpsellModal.Image
      stepsContent={steps}
      requestDetail={{
        moduleRequested: AvailableModules.projects,
        requestReason: ValidReasons.MissingAddon,
        featureRequested: requestSource.requestEvents,
        requestSource: requestSource.requestSource,
      }}
      onClose={handleModalClose}
      buttonLabel={i18n.t('project_management.modals.upsell_projects_modal.button_label')}
    />
  )
}

export default UpsellProjectsModal
